<template lang="pug">
div
  b-card
    .container-fluid
    .row
      .col-md-12
        .white-box
          h1.box-title.m-b-0 SWAN Proとは 編集
          p.text-muted.m-b-30.font-13 SWAN Proサイトの SWAN Proとはの編集画面
          form.form-horizontal
            .form-group
              label(for='言語').col-md-12 言語
              .col-md-12
                el-select(v-model='formdata.locale', disabled='')
                  el-option(value='en', label='英語')
                  el-option(value='cn', label='中国語') 
                  el-option(value='ja', label='日本語')
                  el-option(value='kr', label='韓国語') 
            .form-group(v-if='formdata.entry_id')
              label(for='他の言語').col-md-12 他の言語 
              .col-md-12
                a(v-if="formdata.locale!='ja'" :href='locale_url.ja' replace) 日本語&nbsp;&nbsp;
                a(v-if="formdata.locale!='en'" :href='locale_url.en' replace) 英語&nbsp;&nbsp;
                a(v-if="formdata.locale!='cn'" :href='locale_url.cn' replace) 中国語&nbsp;&nbsp;
                a(v-if="formdata.locale!='kr'" :href='locale_url.kr' replace) 韓国語&nbsp;&nbsp;
            .form-group
              label.col-md-12 タイトル
              .col-md-12
                el-input(type='text', v-model='formdata.title', placeholder='')
            .form-group
              label.col-md-12 リードテキスト
              .col-md-12
                el-input(type='textarea', v-model='formdata.lead_text', :rows='5')
            .form-group
              label.col-md-12 オブジェクト
                span(style='margin: 20px')
                  el-button(type='primary', icon='el-icon-plus', size='mini', v-on:click='addObject')
              addObject(v-for='(item, index) in formdata.objects', :key='index', :index='index', :objectFormdata='formdata', @deleteObj='deleteObj')
  .card
    .col-md-12
      publicSetting(apiname='overview', :formdata='formdata')
</template>

<script>
import axios from 'axios'
import { mapGetters, mapActions, mapMutations } from 'vuex'
import addObject from './addObject'
import PublicSetting from '@/views/components/swan/common/PublicSetting'
import moment from 'moment'
export default {
  name: 'Top',
  components: {
    addObject,
    PublicSetting
  },
  data () {
    return {
      locale_url: {
        ja: '',
        en: '',
        cn: '',
        kr: ''
      },
      formdata: {
        entry_id: '',
        locale: '',
        title: '',
        lead_text: '',
        objects: [],
        open_date: '',
        open_time: '',
        close_date: '',
        close_time: '',
        created_at: '',
        updated_at: '',
        mod_date: '',
        status: '',
        agree_list: [],
        agree_user: '',
        waiting: false
      },
      count: 0
    }
  },
  created () {
    if (this.$route.query.id) {
      this.locale_url.ja = '?id=' + this.$route.query.id + '&locale=ja'
      this.locale_url.en = '?id=' + this.$route.query.id + '&locale=en'
      this.locale_url.cn = '?id=' + this.$route.query.id + '&locale=cn'
      this.locale_url.kr = '?id=' + this.$route.query.id + '&locale=kr'
      console.log('axios')
      return axios({
        method: 'get',
        url: 'admin/swan/overview/edit?entry_id=' + this.$route.query.id + '&locale=' + this.$route.query.locale,
        baseURL: process.env.API_BASE_URL
      }).then((res) => {
        // console.log(_data)
        if (Object.keys(res.data).length) {
          var _data = res.data
          this.formdata.locale = _data.locale
          this.formdata.entry_id = _data.entry_id
          this.formdata.title = _data.title
          this.formdata.lead_text = _data.lead_text
          this.formdata.objects = _data.objects
          if (_data.open_at) {
            this.formdata.open_date = moment(_data.open_at).format('YYYY-MM-DD')
            this.formdata.open_time = moment(_data.open_at).format('HH:mm')
          }
          if (_data.close_at) {
            this.formdata.close_date = moment(_data.close_at).format('YYYY-MM-DD')
            this.formdata.close_time = moment(_data.close_at).format('HH:mm')
          }
          this.formdata.created_at = moment(_data.created_at).format('YYYY-MM-DD HH:mm:ss')
          this.formdata.updated_at = moment(_data.updated_at).format('YYYY-MM-DD HH:mm:ss')
          this.formdata.status = _data.status
          this.formdata.staff_list = _data.staff_list
          this.formdata.agree_list = _data.agree_list
          this.formdata.waiting = _data.waiting
          if (_data.objects.length > 0) {
            // console.log(1)
            let obj = JSON.stringify(_data.objects)
            this.LOAD_OVERVIEW_OBJECT(JSON.parse(obj))
          }
          // console.log(this.GET_OVERVIEW)
          console.log(this.formdata)
          console.log(this.GET_OVERVIEW)
        } else {
          this.formdata.locale = this.$route.query.locale
          this.formdata.entry_id = this.$route.query.id
          let obj = []
          this.LOAD_OVERVIEW_OBJECT(obj)
        }
      }).catch(function (error) {
        console.log('erro')
        this.formdata.locale = this.$route.query.locale
        this.formdata.entry_id = this.$route.query.id
        let obj = []
        this.LOAD_OVERVIEW_OBJECT(obj)
        this.$message({
          type: 'error',
          message: error
        })
        console.log(error)
      })
    } else {
      // console.log('write')
      console.log(this.formdata)
      this.LOAD_OVERVIEW_OBJECT([])
      this.formdata.locale = 'ja'
    }
  },
  updated () {
    console.log(this.formdata)
  },
  methods: {
    addObject () {
      // console.log(this.formdata)
      this.formdata.objects.push({})
      console.log(this.formdata)
      this.SET_OVERVIEW_ADDOBJECT(0)
      console.log(this.GET_OVERVIEW)
    },
    submit () {
      // console.log(this.GET_OVERVIEW)
      let inputData = JSON.stringify(this.GET_OVERVIEW[0])
      axios({
        baseURL: process.env.API_BASE_URL,
        url: '/admin/swan/overview',
        method: 'POST',
        data: {
          data: inputData
        }
      })
        .then((response) => {
          console.log(response)
        })
        .catch((error) => {
          console.log(error)
        })
    },
    deleteObj (index) {
      console.log(index)
      this.$confirm('オブジェクトを削除しますか？', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning',
        center: true
      }).then(() => {
        console.log('success')
        this.formdata.objects.splice(index, 1)
        this.DELETE_OVERVIEW_OBJECT(index)
        console.log(this.formdata.objects)
        console.log(this.GET_OVERVIEW)
        this.$message({
          type: 'success',
          message: 'Delete completed'
        })
      }).catch(() => {
        console.log('false')
        this.$message({
          type: 'info',
          message: 'Delete canceled'
        })
      })
      // console.log(this.formdata.objects)
    },
    ...mapActions([
      'LOAD_OVERVIEW_OBJECT'
    ]),
    ...mapMutations([
      'SET_OVERVIEW_ADDOBJECT',
      'DELETE_OVERVIEW_OBJECT'
    ])
  },
  computed: {
    ...mapGetters([
      'GET_OVERVIEW'
    ])
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>


// WEBPACK FOOTER //
// src/views/components/swan/overview/edit.vue